/*
 * Restores #offer anchor jumps. Horizon scrolls .page-wrapper, not the document,
 * and Chrome will not fragment-navigate a non-root scroller. behavior 'instant' is
 * deliberate: 'smooth' and 'auto' both abandon long jumps partway. Do not change it.
 *
 * The free-bonus cart automation that used to live below this block was removed in
 * v10. The two $0.00 bonus products are no longer injected into the cart. The bonuses
 * are communicated by the announcement bar, the product bullets, the "included free"
 * strip in snippets/pawpaw-included-free.liquid directly above the checkout button,
 * and the order confirmation email. claude/free-bonus-line-items-aug12.md in the
 * project records what the removed code did and why it existed.
 *
 * IMPORTANT: nothing now pins the bonus variants to quantity 1, and nothing strips
 * them from the cart when the grinder is removed. The two $0.00 products must stay
 * unavailable for direct purchase, or a free item can be ordered on its own with free
 * shipping. Variant ids for reference: 56779591975252 (spare wheel),
 * 56779594170708 (handbook eBook).
 */
(function () {
  var TARGET = '#offer';

  function jump() {
    var el = document.querySelector(TARGET);
    var box = document.querySelector('.page-wrapper');
    if (!el || !box) return false;
    var offset = parseFloat(getComputedStyle(el).scrollMarginTop);
    if (!offset || isNaN(offset)) offset = 90;
    var destination = el.getBoundingClientRect().top + box.scrollTop - offset;
    if (isNaN(destination)) return false;
    box.scrollTo({ top: Math.max(0, destination), behavior: 'instant' });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest ? event.target.closest('a[href="' + TARGET + '"]') : null;
    if (link && jump()) {
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', TARGET);
    }
  });

  window.addEventListener('load', function () {
    if (window.location.hash === TARGET) window.setTimeout(jump, 150);
  });
})();
